import {parseNumericInput, toPersianDigits} from './numericInput';

export const PUBLIC_SILVER_QUOTE_UNIT = 'IRR_PER_GRAM';

const SOURCE_TIME = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})(?:\.\d{1,9})?(Z|[+-]\d{2}:\d{2})?$/;

function timestampParts(value, requireZone = false) {
  if (typeof value !== 'string') return null;
  const match = SOURCE_TIME.exec(value);
  if (!match || (requireZone && (!match[7] || value[10] !== 'T'))) return null;
  const [, year, month, day, hour, minute, second, zone] = match;
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
  if (date.getUTCFullYear() !== Number(year) || date.getUTCMonth() !== Number(month) - 1 || date.getUTCDate() !== Number(day)
    || Number(hour) > 23 || Number(minute) > 59 || Number(second) > 59) return null;
  if (zone && zone !== 'Z' && (Number(zone.slice(1, 3)) > 23 || Number(zone.slice(4)) > 59)) return null;
  if (requireZone && !Number.isFinite(Date.parse(value))) return null;
  return {date, hour, minute, second};
}

export function normalizePublicSilverQuote(payload) {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)
    || payload.unit !== PUBLIC_SILVER_QUOTE_UNIT
    || !Number.isSafeInteger(payload.sellPriceRial) || payload.sellPriceRial <= 0
    || !Number.isSafeInteger(payload.buyPriceRial) || payload.buyPriceRial <= 0
    || !timestampParts(payload.publishedAt) || !timestampParts(payload.checkedAt, true)
    || !['current', 'retained'].includes(payload.connection)) return null;
  return {
    sellPriceRial: payload.sellPriceRial,
    buyPriceRial: payload.buyPriceRial,
    unit: PUBLIC_SILVER_QUOTE_UNIT,
    publishedAt: payload.publishedAt,
    checkedAt: payload.checkedAt,
    connection: payload.connection,
  };
}

export function parseLocalizedPositiveInput(value, {integer = false, maximum = Number.MAX_SAFE_INTEGER} = {}) {
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  const parsed = parseNumericInput(String(value).trim());
  if (!parsed.valid || !/^\d+(?:\.\d+)?$/.test(parsed.value)) return null;
  const fraction = parsed.value.split('.')[1] || '';
  if (integer && /[1-9]/.test(fraction)) return null;
  const number = Number(parsed.value);
  if (!Number.isFinite(number) || number <= 0 || number > maximum || number > Number.MAX_SAFE_INTEGER
    || (integer && !Number.isSafeInteger(number))
    || (number === Number.MAX_SAFE_INTEGER && /[1-9]/.test(fraction))) return null;
  return number;
}

/** Convert only the calendar date. The source's clock has no stated timezone. */
export function formatPublishedQuoteTime(value) {
  const parts = timestampParts(value);
  if (!parts) return '—';
  // Zoned publication instants use the same Tehran clock as receipt times.
  // An unzoned provider clock stays as published; no timezone is invented.
  if (/(Z|[+-]\d{2}:\d{2})$/.test(value)) return formatQuoteCheckedTime(value);
  const date = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
    year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'UTC',
  }).format(parts.date);
  return `${date}، ساعت ${toPersianDigits(`${parts.hour}:${parts.minute}:${parts.second}`)}`;
}

export function formatQuoteCheckedTime(value) {
  if (!timestampParts(value, true)) return '—';
  return new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
    hourCycle: 'h23', timeZone: 'Asia/Tehran',
  }).format(new Date(value));
}
